import { DatePicker } from "@/components";
import { useFormikContext } from "formik";
import moment from "moment";
import StepTitle from "../categoryForms/common/StepTitle";
import { StyledFormControl } from "../categoryForms/common/fields";

const DateSelection = ({ title }) => {
  const { setValues, values } = useFormikContext();

  const handleDateChange = (date) => {
    setValues((prev) => ({
      ...prev,
      start_date: date,
      wposition: "",
      wday: "",
      frequency: "",
    }));
  };

  return (
    <>
      <StepTitle>{title}</StepTitle>
      <StyledFormControl>
        <DatePicker.Calendar
          name="start_date"
          minDate={moment().add(1, "days").format("YYYY-MM-DD")}
          value={values.start_date}
          onChange={handleDateChange}
          format="YYYY-MM-DD"
        />
      </StyledFormControl>
    </>
  );
};

export default DateSelection;
